import React from 'react';
import moment from 'moment';
import {
    Button, Grid, TextField, DialogTitle,
    Dialog, DialogActions,
    DialogContent, Box, DialogContentText,
    FormControl, Input, InputLabel, makeStyles
} from '@material-ui/core';

import KenColors from '../../../Utils/themes/KenColors';
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';

import { useTranslation } from 'react-i18next';
import KenInputField from "../../../global_components/KenInputField";
import KenButton from "../../../global_components/KenButton";
 
const useStyles = makeStyles((theme) => ({
    eventTitle: {
        background: KenColors.eventTitleBackgroundColor,
        padding: 10,
        fontWeight: 600,
        color: KenColors.eventTitleColor
    },
    editorBox: {
        overflow: "auto",
        height: "300px"

    },
    editorWrapper: {
      lineHeight: "1.4rem"
  
    },

}));

const FeedbackEvent = ({ feedbackModalOpen, setFeedbackModalOpen, emailList, handleDynamicMail, eventDetails }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const [mail, setMail] = React.useState(emailList.toString());
    console.log(emailList.toString());

    const [subject, setSubject] = React.useState("Feedback Requested : "+ eventDetails.Subject);
    const [editorState, setEditorState] = React.useState(() =>
        EditorState.createEmpty()
    );
    const {content, setContent} = React.useState('');

    const convertDraftToHtmlAndSetContent = async () => {
        const textContent = await draftToHtml(convertToRaw(editorState.getCurrentContent()));        
        return textContent;
    }
    const onEditorStateChange = (editorState) => {
        setEditorState(editorState);
        convertDraftToHtmlAndSetContent();

    }


    const handleClose = () => {
        setFeedbackModalOpen(false);
    };


    // React.DialoguseEffect(() => {
    //     setMail(emailList.toString());

    // }, []);

    const handleToSendMail = async() => {
        const getText = await convertDraftToHtmlAndSetContent();
        const appendText = "<p>Dear,</p>\n"+getText;

        const payload = {
            "emailMessage":{
                "emailIds":emailList,
                "subject": subject,
                "emailBody": appendText
            }  
        }
        handleDynamicMail(payload);
    }




    return (
        <Dialog open={feedbackModalOpen} onClose={handleClose} maxWidth="lg" fullWidth={true} aria-labelledby="form-dialog-title">

            <DialogContent>
                <Grid item xs={12} sm={12} md={12}>
                    <KenInputField
                        readonly
                        label="Subject"
                        required
                        name="subject"
                        onChange={(e) => setSubject(e.target.value)}
                        value={subject}
                    />
                </Grid>


                <Box xs={12} sm={12} md={12} className={classes.editorBox}>
                    <Editor
                        editorState={editorState}
                        placeholder={t("messages:Please_type_here")}
                        wrapperClassName={classes.editorWrapper}
                        onEditorStateChange={onEditorStateChange}
                        toolbar={{
                            options: ['inline', 'link', 'blockType', 'fontSize', 'list', 'textAlign', 'colorPicker', 'embedded', 'emoji', 'remove'],


                        }}
                    />
                </Box>
            </DialogContent>

            <DialogActions className="mr-2">
                <KenButton variant="outlined" onClick={handleClose} >
                    {t("labels:cancel")}
                </KenButton>
                <KenButton variant="contained" onClick={handleToSendMail} color="primary">
                    {t("labels:send")}
                </KenButton>
            </DialogActions>
        </Dialog>
    );
}

export default FeedbackEvent;